import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    username: "",

    roles: [],

    profile: {
        employeeId: null,
        employeeCode: "",
        personId: null,

        fullName: "",
        firstName: "",
        middleName: "",
        lastName: "",

        emailAddress: "",

        employmentStatus: "",

        dateHired: null
    }
};

const userSlice = createSlice({
    name: "user",

    initialState,

    reducers: {
        setUser(state, action) {
            return {
                ...state,
                ...action.payload
            };
        },

        clearUser() {
            return initialState;
        },
        resetAuth() {
            return initialState;
        }
    }
});

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
